import { UserDetails } from '@wpp-open/core'

import { GA4Action } from 'types/ga4'
import { sha256 } from 'utils/hash'

declare const window: WindowWithDataLayer

export const getGA4UserId = async (email: string) => await sha256(email)

export const getGA4UserData = async (userDetails: UserDetails) => ({
  user_id: await getGA4UserId(userDetails.email),
  user_agency: userDetails.agency || 'unknown',
  user_company: userDetails.company || 'unknown',
  user_department: userDetails.department || 'unknown',
  user_job_role: userDetails.jobTitle || 'unknown',
  user_is_external: 'isExternal' in userDetails ? userDetails.isExternal : 'unknown',
  user_region: userDetails.geoRegion || 'unknown',
  user_country_code: userDetails.countryAlpha2Code || 'unknown',
})

export const trackGAAction = (action: GA4Action) => {
  window.dataLayer.push(action)
}
